/* eslint-disable react/no-unused-state */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogTitle } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import CommonButton from './CommonButton';

/*
* USAGE:
* <CommonModal
    title={this.props.title}
    open={this.props.open}
    onYes={this.props.action1}
    onClose={this.props.action2}
    successButtonText="Save"
    cancelButtonText="Thank you"
    width={'lg|sm|xl'}
    />
*/

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

class CommonModal extends React.Component {
  state = {
    open: true,
    showSpinner: false,
    cancelButtonText: 'Cancel',
    successButtonText: 'Confirm',
    fullWidth: false,
    fullScreen: false,
    isFullScreen: false,
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  componentDidMount = () => {
    const {
      showSpinner,
      open,
      successButtonText,
      cancelButtonText,
      title,
      fullWidth,
      fullScreen,
      isFullScreen,
    } = this.props;
    if (typeof showSpinner !== 'undefined') {
      this.setState({
        showSpinner,
      });
    }
    if (typeof open !== 'undefined') {
      this.setState({
        open,
      });
    }
    if (typeof successButtonText !== 'undefined') {
      this.setState({
        successButtonText,
      });
    }
    if (typeof cancelButtonText !== 'undefined') {
      this.setState({
        cancelButtonText,
      });
    }
    if (typeof title !== 'undefined') {
      this.setState({
        title,
      });
    }
    if (typeof fullWidth !== 'undefined') {
      this.setState({
        fullWidth,
      });
    }
    if (typeof fullScreen !== 'undefined') {
      this.setState({
        fullWidth: fullScreen,
      });
    }
    if (typeof isFullScreen !== 'undefined') {
      this.setState({
        isFullScreen: isFullScreen,
      });
    }
  };

  render() {
    const {
      open,
      onClose,
      children,
      onYes,
      saveBtnDisable,
      width,
      title,
      padded,
      disableEscapeKeyDown,
      disableBackdropClick,
      hideActionbuttons,
      isFullScreen,
      actionbuttonsShowTop,
    } = this.props;
    const paddedProp = padded === undefined ? true : padded;
    const { cancelButtonText, successButtonText } = this.state;
    return (
      <div>
        <Dialog
          keepMounted
          maxWidth={width === undefined ? 'lg' : width}
          TransitionComponent={Transition}
          open={open}
          fullScreen={isFullScreen}
          onClose={onClose}
          aria-labelledby="responsive-dialog-title"
          className="confirm-modal-main"
          disableEscapeKeyDown={disableEscapeKeyDown}
          disableBackdropClick={disableBackdropClick}
        >
          {actionbuttonsShowTop && (
            <React.Fragment>
              {!hideActionbuttons ? (
                <DialogActions style={{ marginBottom: 20, paddingRight: 20 }}>
                  <CommonButton color="secondary" onClick={onClose}>
                    {cancelButtonText}
                  </CommonButton>
                  <CommonButton onClick={onYes} disabled={saveBtnDisable}>
                    {successButtonText}
                  </CommonButton>
                </DialogActions>
              ) : null}
            </React.Fragment>
          )}
          <DialogContent className="modal-border p-0 wide-600">
            {title !== undefined && (
              <DialogTitle className="confirm-modal-title">{title}</DialogTitle>
            )}
            <DialogContent
              className={`confirm-modal-content ${
                paddedProp === false ? 'p-0' : ''
              }`}
              style={title === 'Upload Avatar' ? { width: '600px' } : {}}
            >
              {children}
            </DialogContent>
            {!actionbuttonsShowTop && (
              <React.Fragment>
                {!hideActionbuttons ? (
                  <DialogActions style={{ marginBottom: 20, paddingRight: 20 }}>
                    <CommonButton color="secondary" onClick={onClose}>
                      {cancelButtonText}
                    </CommonButton>
                    <CommonButton onClick={onYes} disabled={saveBtnDisable}>
                      {successButtonText}
                    </CommonButton>
                  </DialogActions>
                ) : null}
              </React.Fragment>
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default CommonModal;
